export function siteUrl(): string {
    const viteEnv =
        typeof import.meta !== 'undefined'
        && import.meta
        && typeof import.meta.env === 'object'
        && import.meta.env
            ? (import.meta.env.VITE_SITE_URL as string | undefined)
            : undefined;
    const fromEnv = (
        process.env.VITE_SITE_URL
        ?? process.env.SITE_URL
        ?? viteEnv
    )?.trim();
    if (fromEnv) return fromEnv.replace(/\/+$/, '');

    const vercel = process.env.VERCEL_URL?.trim();
    if (vercel) {
        const host = vercel.replace(/^https?:\/\//, '');
        return `https://${host}`;
    }

    return 'https://ashkelon.news';
}

export function absoluteUrl(path: string): string {
    const origin = siteUrl();
    if (!path || path === '/') return origin;
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${origin}${p}`;
}

export const SITE_NAME = 'אשקלון ניוז';

/**
 * Homepage & default document title (before site-name suffix).
 * Targets the high-impression query "חדשות אשקלון" while keeping brand in the suffix.
 */
export const SITE_HOME_TITLE = 'חדשות אשקלון';

/** Default meta description / RSS channel blurb. */
export const SITE_DESCRIPTION =
    'חדשות אשקלון היום: מבזקים ועדכונים שוטפים מהעיר, כלכלה, חינוך, ספורט, תרבות ודיווחים מהשטח. אשקלון ניוז - המקומון של אשקלון מאז 2006.';

export const SITE_KEYWORDS =
    'אשקלון, חדשות אשקלון, אשקלון חדשות, אשקלון ניוז, חדשות אשקלון היום, חדשות אשקלון מבזקים, חדשות מקומיות, ספורט אשקלון, מזג האוויר אשקלון';

/** Homepage fragment id for the daily arrowword band (`/#arrowword`). */
export const HOMEPAGE_ARROWWORD_HASH = 'arrowword';
